import MarkdownDocs from 'docs/src/modules/components/MarkdownDocs';
import * as pageProps from 'docsx/data/data-grid/performance/performance.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
